import { useEffect, useState, useCallback } from "react";
import { RootState } from "../../../reducer";
import { Paper } from "../../../tailwindcomponents";
import ManageTeams from "./ManageTeams";
import EditTeam from "./EditTeams";
import { Team } from '../../../types/maintenanceTeams';
import TeamOverview from "./TeamOverview";
import MaintenanceTeamsApi from "../../../api/maintenanceTeams";
import { useSelector } from "react-redux";

const TeamsPage = () => {
  const store = useSelector((state: RootState) => state);
  const allEmployees = store.employees.all_employees;
  const [selectedTeam, setSelectedTeam] = useState<Team | null>(null);
  const [teams, setTeams] = useState<Team[]>([]);
  const [loading, setLoading] = useState(true);

  const isTeamAdmin = store.user.me?.user_clearence_groups?.some(group => group === "Team Lead Edit") || false;
  const fetchTeams = useCallback(() => {
    setLoading(true);
    if (!isTeamAdmin) {
      MaintenanceTeamsApi.GetTeamsByEmployee(store.user.me?.user_id)
        .then(res => {
          if (res.teams && Array.isArray(res.teams)) {
            setTeams([...res.teams].sort((a, b) => a.TeamName.localeCompare(b.TeamName)));
          } else {
            setTeams([]);
            setSelectedTeam(null);
          }
        })
        .catch(() => {
          setTeams([]);
          setSelectedTeam(null);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {

      MaintenanceTeamsApi.GetTeams()
        .then(res => {
          if (res.teams && Array.isArray(res.teams)) {
            setTeams([...res.teams].sort((a, b) => a.TeamName.localeCompare(b.TeamName)));
            // Update selectedTeam if one is currently selected
            if (selectedTeam) {
              const updatedTeam = res.teams.find(t => t.Id === selectedTeam.Id);
              if (updatedTeam) {
                setSelectedTeam(updatedTeam);
              } else {
                // Team was deleted, clear selection
                setSelectedTeam(null);
              }
            }
          } else {
            setTeams([]);
            setSelectedTeam(null);
          }
        })
        .catch(() => {
          setTeams([]);
          setSelectedTeam(null);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedTeam]);

  useEffect(() => {
    fetchTeams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only fetch on mount

  return (
    <div className="p-8 min-h-screen h-auto rounded-lg bg-[#f4f6f8]">
      {isTeamAdmin && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Left Panel */}
          <div className="md:col-span-1">
            <Paper className="p-4" style={{ borderRadius: 12 }}>
              <ManageTeams
                teams={teams}
                selectedTeam={selectedTeam}
                onSelectTeam={setSelectedTeam}
                onTeamCreated={fetchTeams}
              />
            </Paper>
          </div>

          {/* Right Panel */}
          <div className="md:col-span-2">
            <Paper className="p-6" style={{ borderRadius: 12 }}>
              <EditTeam team={selectedTeam} employees={allEmployees} onTeamUpdated={fetchTeams} />
            </Paper>
          </div>
        </div>
      )
      }
      <div className="mt-4">
        <TeamOverview teams={teams} loading={loading} employees={allEmployees} />
      </div>
    </div>
  );
};

export default TeamsPage;